var map = {
	"./seating-banquet.svg": "f947",
	"./seating-boardroom.svg": "12aa",
	"./seating-cabaret.svg": "4e1a",
	"./seating-classroom.svg": "5c09",
	"./seating-cocktail.svg": "1214",
	"./seating-dinner-dance.svg": "23f6",
	"./seating-theatre.svg": "b780",
	"./seating-ushaped.svg": "946f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0d8f";